module.exports = __webpack_public_path__ + "static/media/image-login.a71a2ac3.png";